/**
 * @ngdoc service
 * @name common.service:CountryService
 * @requires DUTTI_CONS
 * @description
 * Country service wrapper.
 */
(function() {
    'use strict';

    angular
        .module('itxApp.common')
        .service('CountryService', CountryService);

    CountryService.$inject = [
        '$q',
        'DUTTI_CONS',
        '$http'
    ];

    function CountryService(
        $q,
        DUTTI_CONS,
        $http
    ) {
        var _this = this;

        _this.countries = null;
        _this._cachedCountries = null;

        _this.geoBlockingGroupName = 'ZONAGEOGRAFICA';

        var service = {
            is: _is,
            in: _in,
            getCountries: getCountries,
            getCountriesListName: getCountriesListName,
            getCurrentCountryCode: getCurrentCountryCode,
            getCountriesByGroup: getCountriesByGroup,
            getStoreIdByCountryCode: getStoreIdByCountryCode,
            getCountryJsonByCountryCode: getCountryJsonByCountryCode,
            updateCountryContinent:updateCountryContinent,
            isWWCountry: _isWWCountry,
            isWWCountryId:_isWWCountryId
        };

        return service;
        /**
         * @ngdoc method
         * @name getCurrentCountryCode
         * @methodOf  common.service:CountryService
         * @description
         * Return the current country code
         * @returns {string} ISO country code. Example: 'ES'.
         */
        function getCurrentCountryCode() {
            if(inditex.iStoreJSON){
                return inditex.iStoreJSON.countryCode;
            } else {
                return null;
            }
        }
        /**
         * @ngdoc method
         * @name _is
         * @methodOf  common.service:CountryService
         * @description
         * Check if given country store correspond with `inditex.iStoreId`
         * @param {number} country - Country code
         * @returns {boolean} is given country
         */
        function _is(country, storeId) {
            if (storeId) {
                return storeId == country;
            } else {
                return inditex.iStoreId == country;
            }
        }
        /**
         * @ngdoc method
         * @name _in
         * @methodOf  common.service:CountryService
         * @description
         * TODO: check if any country is current country.
         * @param {array} countries - Array of countries.
         * @returns {boolean} in given country
         */
        function _in(countries) {
            return countries;
        }
        /**
         * @ngdoc method
         * @name getStoreIdByCountryCode
         * @methodOf  common.service:CountryService
         * @description
         * Returns the storeId for the given country code
         * @param {string} countryCode Country code
         * @returns {number} in given country
         */
        function getStoreIdByCountryCode(countryCode) {
            return DUTTI_CONS.country[countryCode];
        }
        /**
         * @ngdoc method
         * @name getCountries
         * @methodOf  common.service:CountryService
         * @description
         * Get the list of online stores returns an array of Store objects
         * @param {number} [typeCatalog] - the type of the catalog to use. If included, the store list will be restricted
         *  to this catalog.
         * @returns {array<country>} country array
         * @example
         * <pre> 
            { 
                code: "ES"
                name: "ESPAÑA"
            }
         * </pre>
        */
        function getCountries() {

            var deferred = $q.defer();

            if (_this.countries) {
                deferred.resolve(_this.countries);
                return deferred.promise;
            }

            var action = {
                action: 'catalog:stores',
                params: {
                    brandId: inditex.iBrandId,
                    typeCatalog: undefined
                }
            };
            if (inditex.iLangId) {
                action.params.languageId = inditex.iLangId;
            }

            joyr.rest.xRestExecute([action])
                .done(function(data) {
                    var stores = data[0].stores;
                    var list = [];
                    if (stores && stores.length) {
                        for (var i = 0; i < stores.length; i++) {
                            list.push({
                                countryName: stores[i].countryName,
                                countryCode: stores[i].countryCode,
                                phonePrefix: stores[i].phonePrefix
                            });
                        }
                    }
                    // Sort countries
                    _this.countries = list.sort(function (a, b) {
                        return a.countryName.localeCompare(b.countryName);
                    });
                    deferred.resolve(_this.countries);
                }).Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getCountriesByGroup
         * @methodOf  common.service:CountryService
         * @description
         * Get the list of countries which are in the same group of the current country.
         * @returns {array} country array
         */
        function getCountriesByGroup() {

            var deferred = $q.defer();

            if (_this.countriesByGroup) {
                deferred.resolve(_this.countriesByGroup);
                return deferred.promise;
            }

            _this.countriesByGroup = inditex.iStoreJSON.countryGroups[0].countries.map(function(item){
                return{
                    countryName: item.name,
                    countryCode : item.code
                };
            });

            _this.countriesByGroup  = _.orderBy(_this.countriesByGroup, 'countryName', 'asc');

            deferred.resolve(_this.countriesByGroup);

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getCountriesListName
         * @methodOf common.service:CountryService
         * @description
         * Returns an array of translated countries
         */
        function getCountriesListName() {
            var deferred = $q.defer();

            var action = {
                action: 'bam:country',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                }
            };

            joyr.rest.xRestExecute([action])
                .done(function(data) {
                    var countries = data[0].countries;
                    var CountryList = [];
                    if (countries && countries.length) {
                        for (var i = 0; i < countries.length; i++) {
                            CountryList.push({
                                countryName: countries[i].name,
                                countryCode: countries[i].code,
                            });
                        }
                    }
                    _this._cachedCountries = CountryList;
                    deferred.resolve(CountryList);
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getCountryJsonByCountryCode(countryCode) {
            var deferred = $q.defer();
            var storeId;
            if (_isWWCountry()) {
                storeId = getStoreIdByCountryCode(inditex.iCountryCode);
            } else {
                storeId = getStoreIdByCountryCode(countryCode);
            }


            var url = 'https://' + inditex.iProxyHostStandard + '/itxrest/2/catalog/store/' + storeId + '?languageId=' + inditex.iLangId + '&appId=1&countryISO=' + countryCode;
            $http.get(url)
                .then(function(response) {

                    if (response.status !== 200) {
                        deferred.reject('Invalid Server response', response);
                        return;
                    }
                    deferred.resolve(response.data);

                }).catch(function(error) {

                    deferred.reject(error);

                });
            return deferred.promise;
        }

        function updateCountryContinent(stores) {
            var countryContinent = {
                'AS': 1,'AU': 1,'CX': 1,'CC': 1,'CK': 1,'FJ': 1,'PF': 1,'GU': 1,'KI': 1,'MP': 1,'MH': 1,'FM': 1,'NR': 1,'NC': 1,'NZ': 1,'NU': 1,'PW': 1,'PG': 1,'WS': 1,'SB': 1,'TK': 1,'TO': 1,'TV': 1,'VU': 1,'WF': 1,'CA': 2,'CO': 2,'CR': 2,'EC': 2,'GT': 2,'HN': 2,'MX': 2,'PA': 2,'DO': 2,'US': 2,'AI': 2,'AG': 2,'AR': 2,'AW': 2,'BS': 2,'BB': 2,'BZ': 2,'BM': 2,'BQ': 2,'BR': 2,'KY': 2,'CL': 2,'CW': 2,'DM': 2,'SV': 2,'GF': 2,'GL': 2,'GD': 2,'GP': 2,'GY': 2,'HT': 2,'JM': 2,'MQ': 2,'MS': 2,'BL': 2,'KN': 2,'LC': 2,'MF': 2,'SX': 2,'PM': 2,'VC': 2,'GS': 2,'SR': 2,'TT': 2,'TC': 2,'VG': 2,'VI': 2,'AM': 3,'AZ': 3,'BH': 3,'CN': 3,'TW': 3,'HK': 3,'MO': 3,'GE': 3,'IN': 3,'ID': 3,'IL': 3,'JO': 3,'KZ': 3,'KW': 3,'LB': 3,'MY': 3,'PH': 3,'QA': 3,'SA': 3,'SG': 3,'KR': 3,'TH': 3,'TR': 3,'AE': 3,'VN': 3,'BD': 3,'BN': 3,'KH': 3,'TP': 3,'JP': 3,'OM': 3,'PK': 3,'LK': 3,'AL': 4,'AD': 4,'AT': 4,'BY': 4,'BE': 4,'BA': 4,'BG': 4,'HR': 4,'CY': 4,'CZ': 4,'DK': 4,'DE': 4,'ES': 4,'IC': 4,'EE': 4,'FI': 4,'FR': 4,'GR': 4,'HU': 4,'IT': 4,'LV': 4,'LT': 4,'LU': 4,'MK': 4,'MT': 4,'MC': 4,'NL': 4,'NO': 4,'PL': 4,'PT': 4,'IE': 4,'RO': 4,'RU': 4,'RS': 4,'XK': 4,'SK': 4,'SI': 4,'SE': 4,'CH': 4,'UA': 4,'GB': 4,'AX': 4,'FO': 4,'GG': 4,'JE': 4,'SH': 4,'SM': 4,'VA': 4,'EG': 5,'MA': 5,'TN': 5,'DZ': 5,'AO': 5,'BJ': 5,'BW': 5,'BF': 5,'CM': 5,'CV': 5,'TD': 5,'KM': 5,'CG': 5,'CI': 5,'DJ': 5,'GA': 5,'GM': 5,'GH': 5,'GQ': 5,'KE': 5,'LS': 5,'LR': 5,'MG': 5,'MW': 5,'MV': 5,'ML': 5,'MR': 5,'MU': 5,'YT': 5,'MZ': 5,'NA': 5,'NE': 5,'RE': 5,'RW': 5,'ST': 5,'SN': 5,'SC': 5,'SL': 5,'ZA': 5,'SZ': 5,'TZ': 5,'TG': 5,'UG': 5,'ZM': 5,'NI':2, 'TL': 1, 'ZW': 5 //jshint ignore:line
            };
            _.each(stores, function(store){

                store.continent = ""+countryContinent[store.countryCode];
                if(! store.continent ){
                    
                    store.continent ="4" //Europa by default por si no viene informado 
                }
            });
        }

        /**
         * @ngdoc method
         * @name _isWWCountry
         * @methodOf  common.service:CountryService
         * @description
         * Check if given country correspond with a world wide market
         * @param {number} country - Country Id
         * @returns {boolean} given country is WW
         */

        function _isWWCountry(countryCode) {
            let isoWebCountries = [];
            inditex.getXconfiguracionValue('WEB_WW_COUNTRY_ISOS', function(status, value) {
                if (value) {
                    isoWebCountries = value.split(',');
                }
            });

            return countryCode
                ? isoWebCountries.includes(countryCode)
                : isoWebCountries.includes(inditex.iCountryCode);
        }
        function _isWWCountryId(storeId) {
            let isoWebCountries = ['38009450', '38009451', '38009452', '38009453', '38009454'];
    
            return  isoWebCountries.includes('' + storeId);
                
        }
    
    }

})();